import { gql } from '@apollo/client';

/**
 * Demo device coupons — the third tab under Devices Order. A Shopify code for a DEMO unit:
 * no invoice, no payment, no chase (see apps/api/src/app/order-devices/demo-coupons.service.ts).
 *
 * Operation names match their GraphQL field names so `refetchQueries: ['demoCoupons']` resolves.
 */

const DEMO_COUPON_FIELDS = `
  code
  shopifyDiscountId
  sku
  deviceName
  quantity
  region
  amount
  currency
  customerEmail
  reason
  createdBy
  createdAt
  expiresAt
  used
  usedAt
  lastSyncedAt
  status
`;

/** The ledger. filter.status = ACTIVE | USED | EXPIRED; filter.search spans code/device/reason/issuer. */
export const DEMO_COUPONS = gql`
  query demoCoupons($filter: DemoCouponFilterInput, $pagination: PaginationInput) {
    demoCoupons(filter: $filter, pagination: $pagination) {
      items { ${DEMO_COUPON_FIELDS} }
      total
    }
  }
`;

/** Catalog-priced value of a coupon for this device/quantity/region — what the mint will use. */
export const DEMO_COUPON_QUOTE = gql`
  query demoCouponQuote($sku: String!, $quantity: Int!) {
    demoCouponQuote(sku: $sku, quantity: $quantity) {
      sku
      deviceName
      quantity
      currency
      region
      unitPrice
      deviceAmount
      shippingAmount
      shippingUnitPrice
      totalAmount
    }
  }
`;

/**
 * Mint the code. Note what is NOT sent: no price (unless the operator overrode it), no ship-to
 * region (demo devices are US only), no operator identity (the server takes it from the caller)
 * and no expiry (fixed at 30 days server-side).
 */
export const CREATE_DEMO_COUPON = gql`
  mutation createDemoCoupon($input: CreateDemoCouponInput!) {
    createDemoCoupon(input: $input) { ${DEMO_COUPON_FIELDS} }
  }
`;

/** On-demand redemption check — returns how many codes flipped to used. */
export const SYNC_DEMO_COUPON_USAGE = gql`
  mutation syncDemoCouponUsage($codes: [String!]) {
    syncDemoCouponUsage(codes: $codes)
  }
`;
